/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { Table } from "reactstrap";
import Label from "../../../components/label";
import { connect } from "react-redux";
import Model from "../../../components/customModal";
import { getOrderHistoryAPI } from "../../../apiRoutes";
import MakeAPICall from "../../../apiCalls/common";
import Loader from "../../../components/loader";
import medicareImg from "../../../assets/images/medicare-button.png";
import appRoutes from "../../../routes/appRoutes";

// components
import Anchor from "../../../components/anchor";
import moment from "moment";
import { openUIN } from "../../../utils/common";
import { IS_ASSESSMENT_TYPES } from "../../../constants/helperConstants";

class AssessmentViewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: this.props.auth.userData,
      assessmentId: props.match.params && props.match.params.id ? props.match.params.id : null,
      assessmentData: null,
      apiCall: null,
      apiLoading: true,
      totalDocEarning: 0.00
    };
  };

  componentDidMount() {
    console.log("---------- ", this.props);
    this.setState({
      apiLoading: true
    });
    this.getAssessmentDetails();
  }

  async getAssessmentDetails() {
    const param = {
      assessmentId: this.state.assessmentId
    };
    let apiCallParam = {
      reqType: "GET",
      reqURL: getOrderHistoryAPI,
      dataObj: {},
      params: param,
      headers: {},
      successCallback: res => {
        console.log("Got the assessment details: ", res.data.data.orderHistoryData[0]);
        let earning = 0;
        if (res.data.data.orderHistoryData[0]) {
          var consultPrice = res.data.data.orderHistoryData[0].consultPrice.toFixed(2);
          const PMFee = res.data.data.orderHistoryData[0].PMFee ? (+res.data.data.orderHistoryData[0].PMFee).toFixed(2) : 0;
          const taxAmount = res.data.data.orderHistoryData[0].tax ? (+res.data.data.orderHistoryData[0].tax).toFixed(2) : 0;

          let bulkBillIncentiveEarning = 0;
          if (res.data.data.orderHistoryData[0].isBulkIncentiveAdded) {
            bulkBillIncentiveEarning = res.data.data.orderHistoryData[0].bulkIncentiveDetails.price ? +res.data.data.orderHistoryData[0].bulkIncentiveDetails.price : 0;
            // consultPrice = (+consultPrice + +res.data.data.orderHistoryData[0].bulkIncentiveDetails.price).toFixed(2);
          }

          const sumOfTotalConsultCost = +consultPrice + +bulkBillIncentiveEarning;
          earning = (sumOfTotalConsultCost - PMFee - taxAmount).toFixed(2);
        }
        this.setState({
          apiLoading: false,
          assessmentData: res.data.data.orderHistoryData[0],
          totalDocEarning: earning
        });
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
        this.setState({
          apiLoading: false
        });
      }
    };
    this.setState({
      apiCall: apiCallParam
    });
  }

  goBack() {
    // this.props.history.goBack();
    if (this.state.assessmentData && this.state.assessmentData.assessmentType === IS_ASSESSMENT_TYPES.MEDICINAL_CANNABIS) {
      this.props.history.push(appRoutes.instantLeaf);
    } else {
      this.props.history.push(appRoutes.instantSwitch);
    }
  }

  openAttachment(attachment) {
    window.open(attachment.url, "_blank");
  }

  render() {
    return (
      <div className="row rounded p-3 assessment-page">
        <div className="col-sm-12 p-3">
          <p onClick={() => this.goBack()}
             className="p-0 m-0 insta-link-orange font-15 text-decoration-none cursor-pointer">
            <i className="fas fa-arrow-left"></i>{" "}
            <span className="ml-1 pt-1 back-btn-text">
                            {" "}
              Back to Assessment List
                        </span>
          </p>
        </div>
        <div className="w-100 border"></div>
        {
          this.state.assessmentData && (
            <Fragment>
              <div className="col-sm-12 p-0 mt-3">

                <div className="card w-100 p-3">
                  <div className="row p-0 m-0">

                    <div className="col-sm-3 center-align-with-flex">
                      <img src={this.state.assessmentData.patientId.profilePic.original}
                           className="user-profile-pic-auto-width" alt="User_IMG" />
                    </div>

                    <div className="col-sm-4 center-align-with-flex">
                      <div className="row">
                        <div className="col-sm-12"
                             onClick={() => {
                               openUIN(this.state.assessmentData.patientId, this.state.auth.accessToken);
                             }}>
                          <Label
                            className="m-0 cursor-pointer"
                            title="UIN: "
                          />
                          <Label
                            className="secondary-font m-0 cursor-pointer ml-2 insta-link-orange"
                            title={this.state.assessmentData.patientId.patientId}
                          />
                        </div>
                        <div className="col-sm-12">
                          <Label
                            className="m-0 cursor-pointer"
                            title="Patient Name: "
                          />
                          <Label
                            className="secondary-font m-0 cursor-pointer ml-2"
                            title={`${this.state.assessmentData.patientId.firstName} ${this.state.assessmentData.patientId.lastName}`}
                          />
                        </div>
                        <div className="col-sm-12">
                          <Label
                            className="m-0 cursor-pointer"
                            title="Mobile No: "
                          />

                          <Label
                            className="secondary-font m-0 cursor-pointer ml-2"
                            title={this.state.assessmentData.patientId.phoneNumber.length > 10 ? `${this.state.assessmentData.patientId.phoneNumber}` : `${this.state.assessmentData.patientId.phoneNumber.slice(0, 4)} ${this.state.assessmentData.patientId.phoneNumber.slice(4, 7)} ${this.state.assessmentData.patientId.phoneNumber.slice(7, 10)}`}
                          />

                        </div>
                        <div className="col-sm-12">
                          <Anchor
                            title="Download Online Assessment"
                            href={this.state.assessmentData.assessmentPDF}
                            className="insta-link-orange mr-3 secondary-font font-15"
                            target="_blank"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-5 center-align-with-flex">
                      <div className="row">
                        <div className="col-sm-12">
                          <Label
                            className="m-0 cursor-pointer"
                            title="Assessment ID:"
                          />
                          <Label
                            className="secondary-font m-0 cursor-pointer ml-2"
                            title={this.state.assessmentData.appointmentId}
                          />
                        </div>
                        <div className="col-sm-12">
                          <Label
                            className="m-0 cursor-pointer"
                            title="Billing Type: "
                          />
                          <Label
                            className="secondary-font m-0 cursor-pointer ml-2"
                            title={this.state.assessmentData.isBulkBilled ? "Medicare" : "Private"}
                          />
                        </div>
                        {/* <div className="col-sm-12">
                                                    <Label
                                                        className="m-0 cursor-pointer"
                                                        title="Status: "
                                                    />
                                                    <Label
                                                        className="secondary-font m-0 cursor-pointer ml-2"
                                                        title={MAPPED_ORDER_HISTORY_STATUS[this.state.assessmentData.assessmentStatus]}
                                                    />
                                                </div> */}
                        <div className="col-sm-12">
                          <Label
                            className="m-0 cursor-pointer"
                            title="Submitted Date: "
                          />
                          <Label
                            className="secondary-font m-0 cursor-pointer ml-2"
                            title={moment(this.state.assessmentData.submittedDate).format("DD-MM-YYYY")}
                          />
                        </div>
                        <div className="col-sm-12">
                          <Label
                            className="m-0 cursor-pointer"
                            title="Completed Date: "
                          />
                          <Label
                            className="secondary-font m-0 cursor-pointer ml-2"
                            title={moment(this.state.assessmentData.completedDate).format("DD-MM-YYYY")}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Doctor Earnings */}
                {
                  <div className="col-sm-12 mt-3 p-0">
                    <div className="card w-100 p-3">
                      <div className="row p-0 m-0">
                        <div className="col-sm-12 mb-3 text-center pb-2 border-bottom">
                          <Label
                            className="w-100 m-0 large"
                            title="Cost Details"
                          />
                        </div>

                        <div className="col-sm-12">
                          <div className="row p-0 m-0">
                            <div className={this.state.assessmentData.isBulkBilled ? "col-sm-3" : "col-sm-4"}>
                              <Label
                                className="m-0"
                                title="Consult Cost: "
                              />
                              <Label
                                className="secondary-font m-0 ml-2"
                                title={"$" + (+this.state.assessmentData.consultPrice).toFixed(2)}
                              />

                              {
                                this.state.assessmentData.isBulkIncentiveAdded && (
                                  <div className="mt-2 mb-2">
                                    <Label
                                      className="m-0"
                                      title="Incentive: "
                                    />
                                    <Label
                                      className="secondary-font m-0 ml-2"
                                      title={"$" + this.state.assessmentData.bulkIncentiveDetails.price}
                                    />
                                  </div>
                                )
                              }
                            </div>

                            {
                              !this.state.assessmentData.isBulkBilled && (
                                <div className="col-sm-4 offset-sm-4">
                                  <Anchor
                                    title={this.state.assessmentData.paymentSummary ? "View Consult Receipt" : "Receipt Not Available"}
                                    href={this.state.assessmentData.paymentSummary}
                                    className="insta-link-orange ml-3 secondary-font font-15"
                                    target="_blank"
                                  />
                                </div>
                              )
                            }

                            {
                              this.state.assessmentData.isBulkBilled && (
                                <Fragment>
                                  <div className="col-sm-4">
                                    <Label
                                      className="m-0"
                                      title="MBS Item Number: "
                                    />
                                    <Label
                                      className="secondary-font m-0 ml-2"
                                      title={this.state.assessmentData.consultDetailMedicareId.mbsItemNo}
                                    />
                                    {
                                      this.state.assessmentData.isBulkIncentiveAdded && (
                                        <div className="mt-2 mb-2">
                                          <Label
                                            className="m-0"
                                            title="MBS Item Number: "
                                          />
                                          <Label
                                            className="secondary-font m-0 ml-2"
                                            title={this.state.assessmentData.bulkIncentiveDetails.itemNo}
                                          />
                                        </div>
                                      )
                                    }
                                  </div>

                                  <div className="col-sm-5 p-0">
                                    <img
                                      style={{ height: "25px" }}
                                      src={medicareImg}
                                      alt="medicare-logo"
                                      className="float-left"
                                    />
                                    <p className="mb-0 pt-1">
                                      {!this.state.assessmentData.DB4FormLink && (
                                        <span className="ml-2">
                                                                                    No Bulk-Bill Assignment of Benefit Form DB4
                                                                                    Available
                                                                                </span>
                                      )}
                                      {this.state.assessmentData.DB4FormLink && (
                                        <a
                                          className="insta-link-orange"
                                          href={this.state.assessmentData.DB4FormLink}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          Bulk-Bill Assignment of Benefit Form DB4
                                        </a>
                                      )}
                                    </p>
                                  </div>
                                </Fragment>
                              )
                            }
                          </div>
                        </div>

                        <div className="col-sm-12 mt-1 mb-1 border-bottom"></div>

                        <div className="col-sm-12 mt-2">
                          <div className="row p-0 m-0">
                            <div className="col-md-4">
                              <Label
                                className="m-0"
                                title="Practice Management Fee: "
                              />
                              <Label
                                className="secondary-font m-0 ml-2"
                                title={"$" + (+this.state.assessmentData.PMFee).toFixed(2)}
                              />
                            </div>

                            <div className="col-md-4">
                              <Label
                                className="m-0"
                                title="GST on Practice Management Fee:"
                              />
                              <Label
                                className="secondary-font m-0 ml-2"
                                title={"$" + (+this.state.assessmentData.tax).toFixed(2)}
                              />

                            </div>
                            <div className="col-md-4">
                              <Label
                                className="m-0"
                                title="Doctor's Earning:"
                              />
                              <Label
                                className="secondary-font m-0 ml-2"
                                title={"$" + this.state.totalDocEarning}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }

                {/* <div className="card w-100 p-3 mt-3">
                                    <Label
                                        className="m-0 large"
                                        title="Attachments: "
                                    />
                                    <div className="row">
                                        {
                                            this.state.assessmentData.attachments.map((value, index) => {
                                                return (
                                                    <ShowAttachmentComponent key={index} url={value}></ShowAttachmentComponent>
                                                )
                                            })
                                        }
                                        {
                                            !this.state.assessmentData.attachments.length && (
                                                <div className="col-sm-12">
                                                    <p className="p-0 m-0">No attachments found</p>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div> */}

                <div className="card w-100 p-3 mt-3">
                  <Label
                    className="m-0 large w-100"
                    title="Additional Information: "
                  />
                  <Label
                    className="m-0 w-100"
                    title={this.state.assessmentData.additionalInfo ? this.state.assessmentData.additionalInfo : "-"}
                  />
                </div>
              </div>

              {/* Consult Note */}
              {
                this.state.assessmentData.consultNoteId && (this.state.assessmentData.consultNoteId.isInstantSwitch || this.state.assessmentData.consultNoteId.isInstantSwitchMC) && (
                  <div className="col-sm-12 mt-3 p-0">
                    <div className="card w-100 p-3">
                      <div className="row">
                        <div className="col-sm-12">
                          <Label
                            className="m-0 secondary-font"
                            title="Consult Note: "
                          />

                          <p
                            className={"insta-label "}
                            dangerouslySetInnerHTML={{
                              __html: (
                                this.state.assessmentData.consultNoteId.note
                              ).replace(/\r?\n/g, "<br/>")
                            }}
                          />
                        </div>
                        <div className="col-sm-12">
                          {
                            this.state.assessmentData.consultNoteId.attachments.map((attachment, index) => {
                              return (

                                !attachment.isDeleted ? (
                                  <div className="prescription-attachments cursor-pointer mr-2 mt-2" key={index}>
                                    <div className="pdf-text cursor-pointer"
                                         onClick={() => this.openAttachment(attachment)}>
                                      <Label title="PDF" className="cursor-pointer" />
                                    </div>
                                    <div className="attachment-type-name cursor-pointer"
                                         onClick={() => this.openAttachment(attachment)}>
                                      <Label title="ePrescription.pdf" className="cursor-pointer ml-3" />
                                    </div>
                                  </div>
                                ) : ("")

                              );
                            })
                          }

                          {
                            this.state.assessmentData.consultNoteId.instantSwitchAttachments.map((attachment, index) => {
                              return (
                                <div className="prescription-attachments cursor-pointer mr-2 mt-2 disabled-link "
                                     key={index}>
                                  <div className="pdf-text cursor-pointer gray-bg-new-color"
                                       onClick={() => this.openAttachment(attachment)}>
                                    <i className="fas fa-envelope envelop-btn text-center pl-1 text-white font-17"></i>
                                  </div>
                                  <div className="attachment-type-name cursor-pointer"
                                       onClick={() => this.openAttachment(attachment)}>
                                    <Label title={attachment.type} className="cursor-pointer ml-3" />
                                  </div>
                                </div>
                              );
                            })
                          }

                        </div>
                      </div>
                    </div>
                  </div>
                )
              }

              {/* Treatment Plan */}
              {
                this.state.assessmentData.treatmentPlan && (
                  <div className="col-sm-12 mt-3 p-0">
                    <div className="card w-100 p-3">
                      <div className="row">
                        <div className="col-sm-12">
                          <Label
                            className="m-0 w-100 secondary-font"
                            title="Information for Patient (from Doctor):"
                          />
                          {/* <Label
                                                        className="w-100 m-0"
                                                        title={this.state.assessmentData.treatmentPlan.additionalNoteForEmail ? (this.state.assessmentData.treatmentPlan.additionalNoteForEmail).replace(/\r?\n/g, "<br/>") : '-'}
                                                    /> */}
                          <p
                            className={"insta-label "}
                            dangerouslySetInnerHTML={{
                              __html: this.state.assessmentData.treatmentPlan.additionalNoteForEmail ? (this.state.assessmentData.treatmentPlan.additionalNoteForEmail).replace(/\r?\n/g, "<br/>") : "-"
                            }}
                          />
                        </div>

                        {this.state.assessmentData.assessmentType !== "Medicinal Cannabis" &&
                          <div className="col-sm-12 mt-3">
                            {
                              this.state.assessmentData.treatmentPlan && this.state.assessmentData.treatmentPlan.patientAttachedPDF ? (
                                <Anchor
                                  title="Attached Pamphlet"
                                  href={this.state.assessmentData.treatmentPlan.patientAttachedPDF}
                                  className="insta-link-orange secondary-font font-15"
                                  target="_blank"
                                />
                              ) : ("")
                            }
                            {
                              this.state.assessmentData.treatmentPlan.nicovapeQPDF && Array.isArray(this.state.assessmentData.treatmentPlan.nicovapeQPDF) ? (
                                this.state.assessmentData.treatmentPlan.nicovapeQPDF.map((attachment, index) => {
                                  return (
                                    <Anchor
                                      title={attachment.filename}
                                      href={attachment.path}
                                      className="insta-link-orange ml-3 secondary-font font-15"
                                      target="_blank"
                                    />
                                  )
                                })
                              ) : ('')
                            }
                            {
                              this.state.assessmentData.treatmentPlan.nicovapeQPDF && !Array.isArray(this.state.assessmentData.treatmentPlan.nicovapeQPDF) ? (
                                <Anchor
                                  title="Welcome To Nicovape Q"
                                  href={this.state.assessmentData.treatmentPlan.nicovapeQPDF}
                                  className="insta-link-orange ml-3 secondary-font font-15"
                                  target="_blank"
                                />
                              ) : ('')
                            }


                            {
                              this.state.assessmentData.treatmentPlan.allowSyncPDF && this.state.assessmentData.treatmentPlan.allowSyncPDF.length ? (
                                this.state.assessmentData.treatmentPlan.allowSyncPDF.map((attachment, index) => {
                                  return (
                                    <Anchor
                                      key={index}
                                      title={attachment.filename}
                                      href={attachment.path}
                                      className="insta-link-orange ml-3 secondary-font font-15"
                                      target="_blank"
                                    />
                                  )
                                })
                              ) : ('')
                            }
                            {
                              this.state.assessmentData.treatmentPlan.veevPDF && this.state.assessmentData.treatmentPlan.veevPDF.length ? (
                                this.state.assessmentData.treatmentPlan.veevPDF.map((attachment, index) => {
                                  return (
                                    <Anchor
                                      key={index}
                                      title={attachment.filename}
                                      href={attachment.path}
                                      className="insta-link-orange ml-3 secondary-font font-15"
                                      target="_blank"
                                    />
                                  )
                                })
                              ) : ('')
                            }
                            {
                              this.state.assessmentData.treatmentPlan.wildByInstictPDF && this.state.assessmentData.treatmentPlan.wildByInstictPDF.length ? (
                                this.state.assessmentData.treatmentPlan.wildByInstictPDF.map((attachment, index) => {
                                  return (
                                    <Anchor
                                      key={index}
                                      title={attachment.filename}
                                      href={attachment.path}
                                      className="insta-link-orange ml-3 secondary-font font-15"
                                      target="_blank"
                                    />
                                  )
                                })
                              ) : ('')
                            }
                            {
                              this.state.assessmentData.treatmentPlan.lulaPDF && this.state.assessmentData.treatmentPlan.lulaPDF.length ? (
                                this.state.assessmentData.treatmentPlan.lulaPDF.map((attachment, index) => {
                                  return (
                                    <Anchor
                                      key={index}
                                      title={attachment.filename}
                                      href={attachment.path}
                                      className="insta-link-orange ml-3 secondary-font font-15"
                                      target="_blank"
                                    />
                                  )
                                })
                              ) : ('')
                            }
                          </div>}

                        {
                          this.state.assessmentData.treatmentPlan.types.length ? (
                            <div className="col-sm-12 mt-3">

                              <Table>
                                <thead>
                                <tr>
                                  <th>Type</th>
                                  <th>Selected Drug</th>
                                  <th>Drug Information</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.assessmentData.treatmentPlan.types.map((selectedType, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>{selectedType.typeName} {selectedType.combinationTherapyType ? " - " + selectedType.combinationTherapyType : ""}</td>
                                      <td> {selectedType.drug ? selectedType.drug : "-"}</td>
                                      <td>
                                        {
                                          selectedType.drugs.map((drugInfo, i2) => {
                                            return (
                                              <div className="drugInfo-container" key={i2 + i2}>
                                                <div className="drugInfo">
                                                  <p className="title">Name</p>
                                                  <p className="content">{drugInfo.name}</p>
                                                </div>
                                                <div className="drugInfo">
                                                  <p className="title">Strength</p>
                                                  <p className="content">{drugInfo.strength || "-"}</p>
                                                </div>
                                                <div className="drugInfo">
                                                  <p className="title">Form Type</p>
                                                  <p className="content">{drugInfo.formType || "-"}</p>
                                                </div>
                                                <div className="drugInfo">
                                                  <p className="title">Dose</p>
                                                  <p className="content">{drugInfo.dose || "-"}</p>
                                                </div>
                                                <div className="drugInfo">
                                                  <p className="title">Frequency</p>
                                                  <p className="content">{drugInfo.frequency || "-"}</p>
                                                </div>
                                                <div className="drugInfo">
                                                  <p className="title">Quantity</p>
                                                  <p className="content">{drugInfo.quantity || "-"}</p>
                                                </div>
                                                <div className="drugInfo">
                                                  <p className="title">Repeats</p>
                                                  <p className="content">{drugInfo.repeats || "-"}</p>
                                                </div>
                                                {!!drugInfo.miniIntervalRepeats && <div className="drugInfo">
                                                  <p className="title">Interval Between Repeats (Days)</p>
                                                  <p className="content">{drugInfo.miniIntervalRepeats}</p>
                                                </div>}
                                                {!!drugInfo.category && <div className="drugInfo">
                                                  <p className="title">TGA Product Category</p>
                                                  <p className="content">{drugInfo.category}</p>
                                                </div>}
                                                {!!drugInfo.indication && <div className="drugInfo">
                                                  <p className="title">Indication</p>
                                                  <p className="content">{drugInfo.indication}</p>
                                                </div>}
                                                <div className="drugInfo">
                                                  <p className="title">Regulation 24</p>
                                                  <p className="content">{drugInfo.regulation24 ? "Yes" : "No"}</p>
                                                </div>
                                                <div className="drugInfo">
                                                  <p className="title">Other Details</p>
                                                  <p className="content">{drugInfo.otherPrescriptionDetails || "-"}</p>
                                                </div>
                                              </div>
                                            );
                                          })
                                        }

                                        {
                                          !selectedType.drugs.length && ("-")
                                        }
                                      </td>
                                    </tr>
                                  );
                                })}
                                </tbody>
                              </Table>
                            </div>
                          ) : ("")
                        }
                      </div>
                    </div>
                  </div>
                )
              }
            </Fragment>
          )
        }

        {/* Success API Model  */}
        <Model
          openModal={this.state.isSuccessModelOpen}
          modalBodyContent={
            <p className="text-center mb-0">
              Assessment Submitted Successfully
            </p>
          }
          okayText="Save"
          cancelText="Okay"
          title="Instant Consult"
          useOneButton={true}
          cancelEvent={() => {
            this.goBack();
          }}
        />

        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />

        {/* Loader */}
        <Loader loading={this.state.apiLoading} />
      </div>
    );
  }
}

// export default AssessmentViewPage;

// get the store
const mapStateToProps = props => ({
  auth: props.auth.user
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AssessmentViewPage));
